<template>
  <div class="scheduling-content">
    <div class="s-filter-box">
      <a-form layout="inline" :model="form">
        <a-form-item>
          <a-radio-group v-model:value="pressStatus" button-style="solid">
            <a-radio-button
              v-for="item in pressStatusItems"
              :key="item.text"
              :disabled="item.disabled"
              :value="item.value"
            >
              {{ item.text }}
            </a-radio-button>
          </a-radio-group>
          <a-divider type="vertical" style="height: 30px"></a-divider>
        </a-form-item>

        <a-form-item label="Status">
          <a-select v-model:value="form.shipStatus" class="select-w-1">
            <a-select-option
              :key="item.text"
              :value="item.value"
              v-for="item in statusItems"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select
            v-model:value="form.routeId"
            mode="multiple"
            class="select-w-2"
            :max-tag-count="1"
            placeholder="Route ID"
          >
            <a-select-option
              :key="item.routeId"
              :value="item.routeId"
              v-for="item in routeIdItems"
            >
              {{ item.routeId }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select
            v-model:value="form.modelName"
            mode="multiple"
            class="select-w-3"
            :max-tag-count="1"
            placeholder="Modal Name"
          >
            <a-select-option
              :key="item"
              :value="item"
              v-for="item in modelNameItems"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item>
          <a-range-picker
            class="range-w"
            v-model:value="form.dateRange"
            valueFormat="YYYY-MM-DD"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            v-model:value="form.poNumber"
            placeholder="PO Number"
            allowClear
            class="select-w-1"
          ></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="find">
            <template #icon><SearchOutlined /></template>
            Find
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <CardListInput
      :data-list="getData"
      :sort-name="form.timeFilter"
      :press-status="pressStatus"
      @sortDateChange="onSortChange"
      @needRefresh="ssInit"
    ></CardListInput>
  </div>
</template>

<script setup>
  import request from '@/utils/request'
  import { SearchOutlined } from '@ant-design/icons-vue'
  import { ref, computed } from 'vue'
  import { useStore } from 'vuex'
  import { message } from 'ant-design-vue'
  import dayjs from 'dayjs'
  import CardListInput from './components/card-list-input.vue'

  const store = useStore()
  const netGroup = computed(() => store.getters['user/currentNetGroup'])
  // const currentSystem = computed(() => store.getters['user/currentSystem'])
  // start 过滤条件================================================
  const pressStatusItems = ref([
    { text: 'Option', value: 'option' },
    { text: 'STG', value: 'sri' },
    { text: 'Fwd', value: 'fwd' },
  ])
  pressStatusItems.value.forEach(async (item) => {
    const { body } = await request({
      url: '/api/checkUrl',
      params: {
        url: `/input/${item.text}`,
      },
    })
    item.disabled = !body
  })
  const pressStatus = ref('option')
  const start = dayjs().subtract(7, 'day').format('YYYY-MM-DD')
  const end = dayjs().add(3, 'month').format('YYYY-MM-DD')
  const form = ref({
    shipStatus: '3',
    routeId: [],
    timeFilter: 'planPickupDate',
    poNumber: '',
    modelName: [],
    dateRange: [start, end],
  })
  const statusItems = ref([{ text: 'Not COMPLETED', value: '3' }])
  const getShipStatus = async function () {
    const { body } = await request({
      url: '/api/shipment/getShipStatus',
    })
    statusItems.value = statusItems.value.concat(body)
  }

  const routeIdItems = ref([])
  const getRouteIds = async function () {
    const { body } = await request({
      url: '/api/shipment/getRouteIds',
    })
    routeIdItems.value = body || []
  }
  const modelNameItems = ref([])
  const getModelNames = async function () {
    const { body } = await request({
      url: '/api/shipment/getModelNames',
    })
    modelNameItems.value = body || []
  }
  const init = () => {
    getRouteIds()
    getShipStatus()
    getModelNames()
  }
  init()

  // end 过滤条件=========================================================

  // start 主体内容================================================
  const getData = ref([])
  const ssInit = async () => {
    const hide = message.loading('Loading……', 0)
    const rawData = { ...form.value }
    rawData.start = dayjs(form.value.dateRange[0]).valueOf()
    rawData.end = dayjs(form.value.dateRange[1]).add(1, 'day').valueOf() - 1
    rawData.modelName = rawData.modelName.join()
    rawData.routeId = rawData.routeId.join()
    rawData.netGrp = netGroup.value
    delete rawData.dateRange
    try {
      const { body } = await request({
        url: '/api/shipment/findDeliveryView',
        params: rawData,
      })
      getData.value = body

      hide()
    } catch (e) {
      hide()
      getData.value = []
    }
  }
  ssInit()

  const find = () => {
    ssInit()
  }
  const onSortChange = (v) => {
    form.value.timeFilter = v
    ssInit()
  }
  // end 主体内容=========================================================
</script>

<style lang="less" scoped>
  @import './less/index.less';
  .s-filter-box {
    padding: 10px;
    background: #f2f3f5;
    border-bottom: 1px solid #dbdcdc;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
